import { Button, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useFlexibleStepper } from 'src/components/FlexibleStepper/useFlexibleStepper';
import FormInput from 'src/components/common/form/FormInput';
import { EmailInputStepProps } from 'src/features/auth/presentation/components/SignUpStepper/SignUpStepper.types';
import useTrackAuthEvents from 'src/features/auth/presentation/hooks/useTrackAuthEvents';
import { createRemoveAllSpacesBlurHandler } from 'src/utils/strings/createRemoveAllSpacesBlurHandler';

export default function EmailInputStep({
  onSubmit,
  disableNext,
  title,
  description,
  submitLabel,
  fieldKey = 'email',
}: EmailInputStepProps) {
  const stepperContext = useFlexibleStepper();
  const { trackRegistrationFieldBlur } = useTrackAuthEvents();
  const { values, handleChange, handleBlur, touched, errors, setFieldValue } =
    useFormikContext<{ [x: typeof fieldKey]: string }>();

  const hasErrors = Boolean(errors[fieldKey]);
  const isEmailEmpty = !values[fieldKey];
  const disableSubmit = hasErrors || isEmailEmpty || disableNext;

  const handleEmailBlur = createRemoveAllSpacesBlurHandler(
    'email',
    setFieldValue,
    handleBlur
  );

  return (
    <>
      <Typography
        variant="h5"
        textAlign="center"
        fontWeight="fontWeightMedium"
        gutterBottom
      >
        {title ?? 'Ingresa tu correo electrónico'}
      </Typography>
      {description && (
        <Typography
          textAlign="left"
          variant="body1"
          fontWeight="fontWeightRegular"
        >
          {description}
        </Typography>
      )}
      <FormInput
        type="email"
        id="email"
        name="email"
        required
        value={values[fieldKey]}
        onChange={handleChange}
        onBlur={handleEmailBlur}
        onInputTrack={trackRegistrationFieldBlur}
        placeholder="melomerezco@pari.mx"
        error={touched[fieldKey] && !!errors[fieldKey]}
        helperText={touched[fieldKey] && errors[fieldKey]}
        textCase="lowercase"
        blockAllSpaces
      />
      <Button
        variant="contained"
        color="primary"
        size="large"
        disabled={disableSubmit}
        onClick={() => onSubmit(stepperContext)}
        sx={{ marginTop: 'auto' }}
      >
        {submitLabel ?? 'Continuar'}
      </Button>
    </>
  );
}
